package com.milta.feature.profile.data.remote

import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.ApiException
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.profile.data.remote.dto.ConfirmAccountDeletionRequest
import com.milta.feature.profile.data.remote.dto.ConfirmPhoneChangeRequest
import com.milta.feature.profile.data.remote.dto.LinkCodeResponse
import com.milta.feature.profile.data.remote.dto.ProfileResponse
import com.milta.feature.profile.data.remote.dto.RequestPhoneChangeRequest
import com.milta.feature.profile.data.remote.dto.UpdateLanguageRequest
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.patch
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess

class ProfileApi(private val client: HttpClient) {

    suspend fun getProfile(): ProfileResponse {
        val response = client.get("$baseUrl/${Endpoints.profile}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    /** GET /api/v1/profile/link-code — MIL-49, Driver-only, idempotent (see Endpoints.profileLinkCode). */
    suspend fun getLinkCode(): LinkCodeResponse {
        val response = client.get("$baseUrl/${Endpoints.profileLinkCode}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
        return response.body()
    }

    suspend fun updateLanguage(request: UpdateLanguageRequest) {
        val response = client.patch("$baseUrl/${Endpoints.profileLanguage}") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }

    suspend fun requestPhoneChange(request: RequestPhoneChangeRequest) {
        val response = client.patch("$baseUrl/${Endpoints.profilePhoneRequest}") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }

    suspend fun confirmPhoneChange(request: ConfirmPhoneChangeRequest) {
        val response = client.patch("$baseUrl/${Endpoints.profilePhoneConfirm}") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }

    suspend fun requestAccountDeletion() {
        val response = client.post("$baseUrl/${Endpoints.profileDeleteRequest}")
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }

    suspend fun confirmAccountDeletion(request: ConfirmAccountDeletionRequest) {
        val response = client.post("$baseUrl/${Endpoints.profileDeleteConfirm}") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }
        if (!response.status.isSuccess()) {
            val apiError = runCatching { response.body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${response.status.value}"
            throw ApiException(response.status.value, message)
        }
    }
}
